import { OFFER_SOURCE } from '@frontend/applications/AffiliatesApp/types/globalTypes';

export const isOfferShopify = (offerSource: OFFER_SOURCE): offerSource is OFFER_SOURCE.SHOPIFY =>
  offerSource === OFFER_SOURCE.SHOPIFY;
export const isOfferTune = (offerSource: OFFER_SOURCE): offerSource is OFFER_SOURCE.TUNE =>
  offerSource === OFFER_SOURCE.TUNE;
